import { UPDATE_PATIENT_NUMBER_FOR_AUDIO_CALL } from "./ActionTypes";


export class OverrideActions {
    static overridePatientNumberForAudioCall(phoneNumber: number) {
        return { type: UPDATE_PATIENT_NUMBER_FOR_AUDIO_CALL, phoneNumber }
    }
}